import React from "react";
import CallStatusDonutWidget, { CallStatusDonutWidgetData } from "./CallStatusDonutWidget";

interface InboundDirectCallsDistributionWidgetProps {
  data: CallStatusDonutWidgetData;
  icon?: React.ReactNode;
  loading?: boolean;
  error?: string;
  onClick?: (filters: { [key: string]: string[] }) => void;
}

const InboundDirectCallsDistributionWidget: React.FC<InboundDirectCallsDistributionWidgetProps> = (props) => (
  <CallStatusDonutWidget
    {...props}
    title="Inbound Direct Calls Distribution"
    tooltipDescription="The percentage of inbound direct calls that were successfully answered versus those that were missed within the given time."
    directionFilterLabel="Inbound Direct"
    legendVerticalAlign="middle"
  />
);

export default InboundDirectCallsDistributionWidget;
